export default __webpack_public_path__ + "static/media/ai_icon_gr.00aff127.png";